<div class="container">
  <div class="img">
    <img src="/assets/signup.png" alt="signup" />
  </div>
  <form class="form" [formGroup]="loginForm">
    <p class="title">Login</p>
    <p class="message">SignIn now and get full access to our app.</p>
    <label>
      <input
        formControlName="email"
        required=""
        placeholder=""
        type="email"
        class="input"
      />
      <span>Email</span>
    </label>

    <label>
      <input
        formControlName="password"
        required=""
        placeholder=""
        type="password"
        class="input"
      />
      <span>Password</span>
    </label>

    <button class="submit" (click)="login()" [disabled]="loginForm.invalid">
      Submit
    </button>
    <button
      class="submit"
      style="
        background-color: transparent;
        color: royalblue;
        border: royalblue solid 1px;
      "
      routerLink="/forget-password"
    >
      Forget Password?
    </button>
    <p class="signin">
      Already have an acount ?
      <a href="#" routerLink="/register" class="text login-link">Signup</a>
    </p>
  </form>
</div>


